import { render, staticRenderFns } from "./XmlCarImage.vue?vue&type=template&id=36fb8e42&scoped=true"
import script from "./XmlCarImage.vue?vue&type=script&lang=js"
export * from "./XmlCarImage.vue?vue&type=script&lang=js"
import style0 from "./XmlCarImage.vue?vue&type=style&index=0&id=36fb8e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb8e42",
  null
  
)

export default component.exports